// extracted by mini-css-extract-plugin
export default {"row":"Row_row__sc08A","row__header":"Row_row__header__ULL+2","row__title":"Row_row__title__Dcasv","tasksEmptyAlert":"Row_tasksEmptyAlert__9gfbR"};